import React from "react";

const values = [
  {
    title: "Trust by default",
    desc: "Clear terms, strong data privacy, and predictable outcomes.",
  },
  {
    title: "Customer first",
    desc: "We optimize for your cash flow and time-to-value.",
  },
  {
    title: "Ship reliably",
    desc: "Quality, uptime, and risk controls over flashy features.",
  },
];

const WhatWeValue = () => {
  return (
    <section className="py-16 bg-white border-t-2 border-[#f4f4f4]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-semibold text-gray-900 mb-8">
          What we value
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {values.map((item, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-xl p-6 bg-white"
            >
              <h4 className="font-semibold text-gray-900 mb-2">
                {item.title}
              </h4>
              <p className="text-gray-600 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeValue;
